import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

export const GET_SUBMISSION_RENEWAL_TYPE_ENTITY = gql`
  query submissionRenewalTypes {
    submissionRenewalTypes {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          name
        }
      }
    }
  }
`;

export function useSubmissionRenewalType({
  enabled = true,
}: {
  enabled?: boolean;
}) {
  const { loading, error, data } = useQuery(
    GET_SUBMISSION_RENEWAL_TYPE_ENTITY,
    { skip: !enabled }
  );
  return {
    error,
    loading,
    data,
  };
}
